export const useForgotPasswordStore = defineStore('forgotPasswordStore', {
  state: () => ({
    lastSendTime: 0,
  }),
  actions: {
    updateLastSendTime() {
      this.lastSendTime = Date.now();
    },
  },
  persist: true,
});
